// Ouverture des PDF IPM servis par l'API authentifiée (jamais d'URL publique). L'onglet est ouvert au
// moment du clic (sinon le navigateur le bloque après l'attente réseau), puis rempli avec le document.
import axios from 'axios';

const API = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api';

export async function ouvrirPdf(token, url, params, fenetre = window.open('', '_blank')) {
  try {
    const r = await axios.get(`${API}${url}`, { params, responseType: 'blob', headers: { Authorization: `Bearer ${token}` } });
    const lien = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    if (fenetre) fenetre.location.href = lien; else window.location.assign(lien);
    setTimeout(() => URL.revokeObjectURL(lien), 120000);
  } catch (e) {
    if (fenetre) fenetre.close();
    throw e;
  }
}

/** Les erreurs d'une requête « blob » arrivent en Blob : on relit le message JSON. */
export async function messageErreurBlob(e, defaut = 'L\'opération n\'a pas abouti.') {
  try { const t = await e.response.data.text(); return JSON.parse(t).message || defaut; } catch { return e?.response?.data?.message || defaut; }
}
